import React, { Component } from 'react';
import Formulario from './LisbrosContablesHome';
import LoadMask from "../Utils/LoadMask/LoadMask";

class LibrosContables extends Component{
    componentDidMount = () => {
        const { getModulo } = this.props;
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4]);
    }
    render(){
        const { loader, modulo } = this.props;
        
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    modulo={modulo}
                />
            </LoadMask>
        );
    }
}

export default LibrosContables;
